import {get} from "../util/http.service";

// Loaded once: the site mutations and the site statuses editor refresh it (see refreshPlanningSites)
export const apiGetPlanningSites = () => ({
  queryKey: ["planning_sites"],
  queryFn: () => get("/api/planning/sites"),
  staleTime: Infinity
});

export const apiGetPlanningEvents = params => ({
  queryKey: ["planning_events", params],
  queryFn: () => get("/api/planning/events", params)
});

export const apiGetPlanningPrestations = params => ({
  queryKey: ["planning_prestations", params],
  queryFn: () => get("/api/planning/prestations", params)
});
